import { render } from "./DefaultProjectCard.vue?vue&type=template&id=856aacdc&scoped=true"
import script from "./DefaultProjectCard.vue?vue&type=script&lang=js"
export * from "./DefaultProjectCard.vue?vue&type=script&lang=js"

import "./DefaultProjectCard.vue?vue&type=style&index=0&id=856aacdc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856aacdc"]])

export default __exports__